import moment from 'moment';
export function minutesToDays(minutes) {
    try {
        var duration = moment.duration(minutes, 'minutes');
        var days = Math.floor(duration.asDays());
        var remainingHours = Math.floor(duration.asHours()) % 24;
        var minutesPart = duration.minutes();
        var text = ""
        text += days > 0 ? days + " ngày " : "";
        text += remainingHours > 0 ? remainingHours + " giờ " : "";
        text += minutesPart > 0 ? minutesPart + " phút " : "";
        return text;
    } catch (error) {
        return "Lỗi: " + error;
    }
}